import axios from "axios"
import { config } from './apiUrl';

export  const getHighlight = (param,id) =>
    axios.get(`${config.getHighlight}?page=${param}&id=${id}&qid=${Date.now()}`)